export const getOrderSourceLabel = (order) => {
  if (!order) return '—';
  if (order.source === 'AGENT') {
    return order.user?.name ? `Agente: ${order.user.name}` : 'Agente';
  }
  return 'Cardápio digital';
};

export const getOrderSourceIcon = (order) =>
  order?.source === 'AGENT' ? 'icon-badge' : 'icon-mobile';

export const getOrderSourceColor = (order) =>
  order?.source === 'AGENT' ? '#7c3aed' : '#00bb33';
